import script from "./FloatingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&setup=true&lang=js"

import "./FloatingMenu.vue?vue&type=style&index=0&id=1895c503&scoped=true&lang=css"

import exportComponent from "../../../../../../../jump-main-reset/서버/jump/jump-user/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1895c503"]])

export default __exports__